import { SearchItem, TransformDetail } from '../../api/models'
import { DataAnalysisTimeSeries } from '../../api/models/data-analysis-time-series'
import { TransformParameter } from '../../api/models/transform-parameter';
import { SmartImageDetail } from '../components/smart-image-list/smart-image-list.component';

export class DataAnalysisConfig {
    period: string;
    from: string;
    to: string;
    leftMin: number;
    leftMax: number;
    rightMin: number;
    rightMax: number;
    leftTitle: string;
    rightTitle: string;
    offset: number;
  
    protected static SInit = (() => {
        DataAnalysisConfig.prototype.offset = 600;
        DataAnalysisConfig.prototype.period = "today";
    })();
  
    timeSeriesList: DataAnalysisItem[];
    timeLapseList:{[key: string]: SmartImageDetail[]};
  }

  /*export class ConfigItem{
    key: string;
    value: any;
    dataType: string;
  }*/

  export class DataAnalysisTransform {
    transform: TransformDetail;
    config: TransformParameter[];
    //todo: add parameters
  }
  
  export class DataAnalysisItem {
    name: string;
    uri: string;
    axis: number;
    type: string;
    source: string;
    transform: string;
    transforms: DataAnalysisTransform[];
    style: string;
    width: number;
    active: boolean;
    colour: string;
    data: DataAnalysisTimeSeries;
    item: SearchItem;
    
    series: any; //highcharts series
  
    protected static SInit = (() => {
      DataAnalysisItem.prototype.axis = 0;
      DataAnalysisItem.prototype.width = 1;
      DataAnalysisItem.prototype.type = "line";
      DataAnalysisItem.prototype.style = "solid";
    })();
  
  }